/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DialogMessageTemplateAuditRestore_Viewer = {
    readonly _id: string;
    readonly " $refType": "DialogMessageTemplateAuditRestore_Viewer";
};
export type DialogMessageTemplateAuditRestore_Viewer$data = DialogMessageTemplateAuditRestore_Viewer;
export type DialogMessageTemplateAuditRestore_Viewer$key = {
    readonly " $data"?: DialogMessageTemplateAuditRestore_Viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DialogMessageTemplateAuditRestore_Viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DialogMessageTemplateAuditRestore_Viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '65af67b546bce904ebb0dea24d55eac2';
export default node;
